/**
 * מנרמל תווית קטגוריה גולמית לערך יציב לתצוגה (אנגלית קטנה).
 * לא מניח שדה קיים — מחזיר "" אם ריק/לא מזוהה.
 *
 * @param {unknown} rawCategory
 * @returns {string}
 */
export function mapAttractionCategory(rawCategory) {
  if (rawCategory == null) return "";
  const s = String(rawCategory).trim();
  if (!s) return "";

  const key = s.toLowerCase().replace(/[_\s]+/g, " ").trim();

  /** @type {Record<string, string>} */
  const aliases = {
    tour: "tours",
    tours: "tours",
    excursion: "excursions",
    excursions: "excursions",
    activity: "activities",
    activities: "activities",
    attraction: "attractions",
    attractions: "attractions",
    show: "shows",
    shows: "shows",
    museum: "museums",
    museums: "museums",
    cruise: "cruises",
    cruises: "cruises",
    water: "water",
    sports: "sports",
    spa: "spa",
    shopping: "shopping",
    food: "food",
    nightlife: "nightlife",
    family: "family",
    other: "other",
  };

  if (aliases[key]) return aliases[key];

  // ערך לא ממופה במפורש — מחזירים מנורמל "slug" בטוח ל-UI
  const slug = key
    .normalize("NFKD")
    .replace(/[^\p{L}\p{N}\s-]/gu, "")
    .trim()
    .replace(/\s+/g, "-");

  return slug || "";
}
